export default __webpack_public_path__ + "static/media/CHMP.e4071db8.jpg";